module.exports = __webpack_public_path__ + "media/cookies/cookie-cba3a001.svg";